import '.a8{width:100%;}.ssr-plugin'
import '.cz{border-radius:0.75rem;}.ssr-plugin'
import '.fn{border:1px solid var(--shades-blue-300);}.ssr-plugin'
import '.fm{padding:0.5rem 1rem;}.ssr-plugin'
import '.di{font-size:1.125rem;}.ssr-plugin'
import '.f7{line-height:1.75rem;}.ssr-plugin'
import '.fo{resize:vertical;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { forwardRef } from 'react'

export type MultiLineTextInputProps = {
  value: string
  placeholder?: string
  minHeight?: string
  style?: Style
  setValue: (value: string) => void
}

export const MultiLineTextInput = forwardRef<
  HTMLTextAreaElement,
  MultiLineTextInputProps
>(
  (
    {
      value,
      placeholder,
      minHeight = '6.5rem',
      style,
      setValue,
    }: MultiLineTextInputProps,
    ref,
  ) => {
    return (
      <styled.textarea className="a8 cz fn fm di f7 fo"
        ref={ref}
        style={{
          minHeight: minHeight,
          '&:focus': {
            outline: 'none',
            border: '1px solid var(--primary-blue)',
          },
          ...style,
        }}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      ></styled.textarea>
    )
  },
)
